import { LikeOn, LikeOff } from '../../../../../shared/images';

import Button from '../../../../../shared/components/Button/Button';

interface Props {
  isActiveLike: boolean;
  toggleLike(): void;
}

export default function LikeButton({
  isActiveLike,
  toggleLike,
}: Props) {
  return (
    <Button
      theme="tertiary"
      text=""
      width={56}
      height={56}
      radius={3}
      styleIcon={{ src: isActiveLike ? LikeOn : LikeOff }}
      onClick={toggleLike}
    />
  );
}
